import { css } from "styled-components";
import { textUppercaseMixin } from "../../../../skins/shared/mixins/typography";
import { ctaCursorMixin, ctaTransitionEffectMixin } from "../mixins";
export const riotProductSkin = (chroma, paletteTokens) => css `
  ${ctaCursorMixin}
  ${textUppercaseMixin};
  ${ctaTransitionEffectMixin}
  ${chroma.typography.body3}
  font-weight: 500;

  &.variant-primary {
    --cta-text-color: ${paletteTokens.ctatext1};
    --cta-bg-color: ${paletteTokens.ctabg1};
    --cta-disabled-text-color: ${paletteTokens.ctatext1_disabled};
    --cta-disabled-bg-color: ${paletteTokens.ctabg1_disabled};
    --cta-hover-text-color: ${paletteTokens.ctatext1_hover};
    --cta-hover-bg-color: ${paletteTokens.ctabg1_hover};
  }

  &.variant-secondary {
    --cta-text-color: ${paletteTokens.ctatext2};
    --cta-bg-color: ${paletteTokens.ctabg2};
    --cta-disabled-text-color: ${paletteTokens.ctatext2_disabled};
    --cta-disabled-bg-color: ${paletteTokens.ctabg2_disabled};
    --cta-hover-text-color: ${paletteTokens.ctatext2_hover};
    --cta-hover-bg-color: ${paletteTokens.ctabg2_hover};
  }

  .cta-content {
    display: flex;
    align-items: center;
    gap: ${chroma.spacers.constant.xs};
  }

  &.variant-primary,
  &.variant-secondary {
    display: block;
    width: fit-content;
    padding: 19px 32px;
    color: var(--cta-text-color);
    background-color: var(--cta-bg-color);

    &.ornamental {
      outline: 1px solid ${paletteTokens.bladetext1};
      outline-offset: 3px;
    }

    .left-icon {
      background-color: var(--cta-text-color);
      ${ctaTransitionEffectMixin}
    }

    &:disabled,
    &.disabled {
      background-color: var(--cta-disabled-bg-color);
      color: var(--cta-disabled-text-color);

      .left-icon {
        background-color: var(--cta-disabled-text-color);
      }
    }

    &:hover:not(.disabled) {
      color: var(--cta-hover-text-color);
      background-color: var(--cta-hover-bg-color);

      & .left-icon {
        background-color: var(--cta-hover-text-color);
      }
    }
  }

  &.variant-tertiary {
    padding: 0;
    color: ${paletteTokens.bladetext1};
    background-color: transparent;

    &:hover:not(.disabled) {
      color: ${paletteTokens.bladetext1_light};
    }

    .tertiary-icon {
      ${ctaTransitionEffectMixin}
      background-color: ${paletteTokens.accents1};
      width: 14px;
      height: 14px;

      ${chroma.mediaQueries.tabletDown} {
        width: 12px;
        height: 12px;
      }

      ${chroma.mediaQueries.mobileDown} {
        width: 10px;
        height: 10px;
      }
    }
  }
`;
//# sourceMappingURL=index.js.map